<template>
	<div id="page-user-edit">
		<vs-row v-if="customer">
			<vs-popup
				class="holamundo"
				:title="method == 'new' ? 'Új telephely' : 'Telephely módosítása'"
				:active.sync="editSiteModal"
				v-if="currentSite"
			>
				<div class="vs-row">
					<form
						data-vv-scope="customerSite"
						v-on:submit.prevent
						autocomplete="off"
					>
						<vs-row>
							<vs-col
								vs-justify="left"
								vs-align="left"
								vs-w="12"
								class="p-2"
							>
								<vs-input
									label-placeholder="Név"
									v-model="currentSite.name"
									class="w-full mt-4"
									name="customerSiteName"
									v-validate="'required'"
									v-on:keyup.enter="saveSite"
								/>
								<span class="text-danger">{{ errors.first('customerSite.customerSiteName') }}</span>
							</vs-col>
						</vs-row>
						<vs-row>
							<vs-col
								vs-w="6"
								class="p-2"
							>
								<vs-button
									class="mr-3 mb-2"
									@click="validateSite()"
								>Mentés</vs-button>
							</vs-col>
						</vs-row>
					</form>
				</div>
			</vs-popup>
			<vs-popup
				class="holamundo"
				:title="method == 'new' ? 'Új ügyintéző' : 'Ügyintéző módosítása'"
				:active.sync="editContactModal"
				v-if="currentContact"
			>
				<div class="vs-row">
					<form
						data-vv-scope="customerContact"
						v-on:submit.prevent
						autocomplete="off"
					>
						<vs-row>
							<vs-col
								vs-justify="left"
								vs-align="left"
								vs-w="6"
								class="p-2"
							>
								<vs-input
									label-placeholder="Vezetéknév"
									v-model="currentContact.firstName"
									class="w-full mt-4"
									name="customerContactFirstName"
									ref="firstName"
									autofocus
									v-validate="'required'"
									v-on:keyup.enter="saveContact"
								/>
								<span class="text-danger">{{ errors.first('customerContact.customerContactFirstName') }}</span>
							</vs-col>
							<vs-col
								vs-justify="left"
								vs-align="left"
								vs-w="6"
								class="p-2"
							>
								<vs-input
									label-placeholder="Keresztnév"
									v-model="currentContact.lastName"
									class="w-full mt-4"
									name="customerContactLastName"
									v-validate="'required'"
									v-on:keyup.enter="saveContact"
								/>
								<span class="text-danger">{{ errors.first('customerContact.customerContactLastName') }}</span>
							</vs-col>
						</vs-row>
						<vs-row>
							<vs-col
								vs-justify="left"
								vs-align="left"
								vs-w="6"
								class="p-2"
							>
								<vs-input
									label-placeholder="E-mail cím"
									v-model="currentContact.email"
									class="w-full mt-4"
									name="email"
									v-on:keyup.enter="saveContact"
								/>
							</vs-col>
							<vs-col
								vs-justify="left"
								vs-align="left"
								vs-w="6"
								class="p-2"
							>
								<vs-input
									label-placeholder="Telefonszám"
									v-model="currentContact.phone"
									class="w-full mt-4"
									name="phone"
									v-on:keyup.enter="saveContact"
								/>
							</vs-col>
						</vs-row>
						<vs-row>
							<vs-col
								vs-justify="left"
								vs-align="left"
								vs-w="12"
								class="p-2"
							>
								<vs-select
									class="w-full"
									label="Telephely"
									v-model="currentContact.siteId"
								>
									<vs-select-item
										v-for="site in customer.sites"
										:key="site.id"
										:value="site.id"
										:text="site.name"
									/>
								</vs-select>
							</vs-col>
						</vs-row>
						<vs-row>
							<vs-col
								vs-w="6"
								class="p-2"
							>
								<vs-button
									class="mr-3 mb-2"
									@click="validateContact()"
								>Mentés</vs-button>
							</vs-col>
						</vs-row>
					</form>
				</div>
			</vs-popup>
			<vs-col
				vs-type="flex"
				:vs-w="newCustomer ? 12 : 12"
				class="sm:p-2 p-4"
			>
				<vx-card>
					<div
						slot="no-body"
						class="tabs-container px-6 pt-6"
					>
						<div class="flex">
							<vs-button
								class="btn-drop"
								type="flat"
								icon-pack="feather"
								size="medium"
								icon="icon-arrow-left"
								@click="$router.go(-1)"
							></vs-button>
							<h4 class="mt-3">
								{{ this.$route.params.id ? 'Megrendelő módosítása' : 'Új megrendelő' }}
							</h4>
						</div>

						<vs-tabs
							v-model="activeTab"
							class="tab-action-btn-fill-conatiner"
						>
							<vs-tab
								label="Alapadatok"
								icon-pack="feather"
								icon="icon-user"
							>
								<div class="tab-text">
									<div class="vs-row">
										<form
											data-vv-scope="customer"
											v-on:submit.prevent
											autocomplete="off"
										>
											<vs-row>
												<vs-col
													vs-justify="left"
													vs-align="left"
													vs-w="6"
													class="p-2"
												>
													<vs-input
														label-placeholder="Név"
														ref="customerName"
														v-model="customer.name"
														class="w-full mt-4"
														name="name"
														v-on:keyup.enter="validate"
														autocomplete="none"
													/>

												</vs-col>
												<vs-col
													vs-justify="left"
													vs-align="left"
													vs-w="6"
													class="p-2"
												>
													<vs-input
														label-placeholder="Adószám"
														v-model="customer.vatNumber"
														class="w-full mt-4"
														name="vatNumber"
														v-on:keyup.enter="validate"
														autocomplete="none"
													/>
												</vs-col>
											</vs-row>
											<vs-row>
												<vs-col
													vs-justify="left"
													vs-align="left"
													vs-w="6"
													class="p-2"
												>
													<vs-input
														label-placeholder="Vezetéknév"
														v-model="customer.firstName"
														class="w-full mt-4"
														name="firstName"
														autocomplete="none"
													/>
												</vs-col>
												<vs-col
													vs-justify="left"
													vs-align="left"
													vs-w="6"
													class="p-2"
												>
													<vs-input
														label-placeholder="Keresztnév"
														v-model="customer.lastName"
														class="w-full mt-4"
														name="lastName"
														autocomplete="none"
													/>
												</vs-col>
											</vs-row>
											<vs-row>
												<vs-col
													vs-justify="left"
													vs-align="left"
													vs-w="6"
													class="p-2"
												>
													<vs-input
														label-placeholder="E-mail cím"
														v-model="customer.email"
														class="w-full mt-4"
														name="email"
														v-validate="'required'"
														v-on:keyup.enter="validate"
														autocomplete="none"
													/>
													<span class="text-danger">{{ errors.first('customer.email') }}</span>
												</vs-col>
												<vs-col
													vs-justify="left"
													vs-align="left"
													vs-w="6"
													class="p-2"
												>
													<vs-input
														label-placeholder="Telefonszám"
														v-model="customer.phone"
														class="w-full mt-4"
														name="phone"
														v-on:keyup.enter="validate"
														autocomplete="none"
													/>
												</vs-col>
											</vs-row>
											<vs-row>
												<vs-col
													vs-justify="left"
													vs-align="left"
													vs-w="4"
													class="p-2"
												>
													<label for="">Irányítószám</label>
													<vs-input
														v-model="customer.zipCode"
														class="w-full"
														name="zipCode"
														v-on:keyup.enter="validate"
														@input="getCityByZipcode('customer')"
														autocomplete="none"
													/>
												</vs-col>
												<vs-col
													vs-justify="left"
													vs-align="left"
													vs-w="8"
													class="p-2"
												>
													<!-- City suggest -->
													<label for="">Város</label>
													<vs-input
														v-model="customer.city"
														class="w-full"
														name="city"
														v-on:keyup.enter="validate"
														autocomplete="none"
													/>
												</vs-col>

											</vs-row>
											<vs-row>
												<vs-col
													vs-justify="left"
													vs-align="left"
													vs-w="4"
													class="p-2"
												>
													<!-- Street suggest -->
													<label for="">Közterület</label>
													<vue-simple-suggest
														class="w-full"
														v-model="customer.street"
														:list="streets"
														:filter-by-query="true"
														display-attribute="streetName"
														value-attribute="id"
														:min-length="3"
														:debounce="200"
														:controls="{
													selectionUp: [38, 33],
													selectionDown: [40, 34],
													select: [13, 36],
													showList: [40],
													hideList: [27, 35]
												}"
														@select="selectStreet"
														autocomplete="none"
													>
													</vue-simple-suggest>
													<!-- END street suggest -->
												</vs-col>
												<vs-col
													vs-justify="left"
													vs-align="left"
													vs-w="4"
													class="p-2"
												>
													<label for="">Közterület jellege</label>
													<vue-simple-suggest
														class="w-full"
														v-model="customer.streetType"
														:list="streetTypes"
														:filter-by-query="true"
														display-attribute="streetType"
														value-attribute="id"
														:min-length="3"
														:debounce="200"
														:controls="{
													selectionUp: [38, 33],
													selectionDown: [40, 34],
													select: [13, 36],
													showList: [40],
													hideList: [27, 35]
												}"
														autocomplete="none"
													>
													</vue-simple-suggest>
												</vs-col>
												<vs-col
													vs-justify="left"
													vs-align="left"
													vs-w="4"
													class="p-2"
												>
													<vs-input
														label="Házszám"
														v-model="customer.houseNumber"
														class="w-full"
														v-on:keyup.enter="validate"
														name="houseNumber"
														autocomplete="none"
													/>
												</vs-col>

											<vs-row>
												<vs-col
													vs-justify="left"
													vs-align="left"
													vs-w="4"
													class="p-2"
												>
													<vs-input
														label="Utolsó sorszám (lakossági)"
														v-model="customer.lastResidentalPhomeId"
														class="w-full"
														v-on:keyup.enter="validate"
														name="lastResidentalPhomeId"
														autocomplete="none"
													/>
												</vs-col>
												<vs-col
													vs-justify="left"
													vs-align="left"
													vs-w="4"
													class="p-2"
												>
													<vs-input
														label="Utolsó sorszám (Vállalati)"
														v-model="customer.lastCompanyPhomeId"
														class="w-full"
														v-on:keyup.enter="validate"
														name="lastCompanyPhomeId"
														autocomplete="none"
													/>
												</vs-col>
												<vs-col
													vs-justify="left"
													vs-align="left"
													vs-w="4"
													class="p-2"
												>
													<vs-input
														label="Leadási határidő (nap)"
														v-model="customer.dueDays"
														class="w-full"
														v-on:keyup.enter="validate"
														name="dueDays"
														autocomplete="none"
													/>
												</vs-col>
											</vs-row>
											</vs-row>

											<vs-row>
												<vs-col
													vs-w="6"
													class="p-2"
												>
													<vs-button
														class="mr-3 mb-2"
														@click="validate()"
													>Mentés</vs-button>
												</vs-col>
											</vs-row>
										</form>
									</div>
								</div>
							</vs-tab>
							<vs-tab
								label="Telephelyek"
								icon-pack="feather"
								icon="icon-info"
								v-if="!newCustomer"
							>
								<div class="tab-text">
									<vs-table
										v-if="customer.sites"
										pagination
										search
										:hoverFlat="true"
										:notSpacer="true"
										:data="customer.sites"
										noDataText="Nincs találat"
									>

										<div
											slot="header"
											class="flex flex-wrap-reverse items-center flex-grow justify-between"
										>
											<vs-row>
												<vs-col
													vs-w="4"
													class="sm:p-2 p-4"
												>
													<vs-button
														type="border"
														size="medium"
														icon-pack="feather"
														icon="icon-plus"
														class="mr-2"
														color="primary"
														@click="addNewSite"
													>
														Új telephely
													</vs-button>

												</vs-col>
											</vs-row>

										</div>

										<template slot="thead">
											<vs-th sort-key="name">Név</vs-th>
											<vs-th></vs-th>
										</template>

										<template slot-scope="{data}">
											<tbody>
												<vs-tr
													:data="customer.sites"
													:key="index"
													v-for="(site, index) in data"
												>

													<vs-td :data="site.name">
														<p class="product-name font-medium truncate">{{ site.name }}</p>
													</vs-td>

													<vs-td class="whitespace-no-wrap">
														<div class="flex pull-right">
															<vx-tooltip
																text="Módosítás"
																v-if="!site.fix"
															>
																<vs-button
																	type="border"
																	size="small"
																	icon-pack="feather"
																	icon="icon-edit"
																	class="mr-2"
																	color="dark"
																	@click.stop="editSite(site)"
																></vs-button>
															</vx-tooltip>
															<vx-tooltip
																text="Törlés"
																v-if="!site.fix"
															>
																<vs-button
																	type="border"
																	size="small"
																	icon-pack="feather"
																	icon="icon-trash-2"
																	color="danger"
																	class="mr-2"
																	@click="deleteSite(site.id)"
																></vs-button>
															</vx-tooltip>
														</div>
													</vs-td>
												</vs-tr>
											</tbody>
										</template>
									</vs-table>
								</div>
							</vs-tab>
							<vs-tab
								label="Ügyintézők"
								icon-pack="feather"
								icon="icon-info"
								v-if="!newCustomer"
							>
								<div class="tab-text">
									<vs-table
										v-if="customer.contacts"
										pagination
										search
										:hoverFlat="true"
										:notSpacer="true"
										:data="customer.contacts"
										noDataText="Nincs találat"
									>

										<div
											slot="header"
											class="flex flex-wrap-reverse items-center flex-grow justify-between"
										>
											<vs-row>
												<vs-col
													vs-w="4"
													class="sm:p-2 p-4"
												>
													<vs-button
														type="border"
														size="medium"
														icon-pack="feather"
														icon="icon-plus"
														class="mr-2"
														color="primary"
														@click="addNewContact"
													>
														Új ügyintéző
													</vs-button>

												</vs-col>
											</vs-row>

										</div>

										<template slot="thead">
											<vs-th sort-key="fullName">Név</vs-th>
											<vs-th sort-key="email">E-mail cím</vs-th>
											<vs-th sort-key="phone">Telefonszám</vs-th>
											<vs-th sort-key="site">Telephely</vs-th>
											<vs-th></vs-th>
										</template>

										<template slot-scope="{data}">
											<tbody>
												<vs-tr
													:data="customer.contacts"
													:key="index"
													v-for="(contact, index) in data"
												>

													<vs-td :data="contact.fullName">
														<p class="product-name font-medium truncate">{{ contact.fullName }}</p>
													</vs-td>

													<vs-td :data="contact.email">
														<p class="product-name font-medium truncate">{{ contact.email }}</p>
													</vs-td>

													<vs-td :data="contact.phone">
														<p class="product-name font-medium truncate">{{ contact.phone }}</p>
													</vs-td>

													<vs-td :data="contact.site.name">
														<p class="product-name font-medium truncate">{{ contact.site.name }}</p>
													</vs-td>

													<vs-td class="whitespace-no-wrap">
														<div class="flex pull-right">
															<vx-tooltip text="Módosítás">
																<vs-button
																	type="border"
																	size="small"
																	icon-pack="feather"
																	icon="icon-edit"
																	class="mr-2"
																	color="dark"
																	@click.stop="editContact(contact)"
																></vs-button>
															</vx-tooltip>
															<vx-tooltip text="Törlés">
																<vs-button
																	type="border"
																	size="small"
																	icon-pack="feather"
																	icon="icon-trash-2"
																	color="danger"
																	class="mr-2"
																	@click="deleteContact(contact.id)"
																></vs-button>
															</vx-tooltip>
														</div>
													</vs-td>
												</vs-tr>
											</tbody>
										</template>
									</vs-table>
								</div>
							</vs-tab>
						</vs-tabs>

					</div>
				</vx-card>
			</vs-col>
			<!-- <vs-col
				vs-type="flex"
				vs-w="4"
				class="sm:p-2 p-4"
				v-if="!newCustomer"
			>
				<vx-card title="Ügyletek">
					<vs-table
						v-if="customer.transactions"
						pagination
						:hoverFlat="true"
						:data="customer.transactions"
						noDataText="Nincs találat"
					>

						<template slot="thead">
							<vs-th>Azonosító</vs-th>
							<vs-th>Típus</vs-th>
							<vs-th>Ingatlan</vs-th>
							<vs-th></vs-th>
						</template>

						<template slot-scope="{data}">
							<tbody>
								<vs-tr
									:data="customer.transactions"
									:key="index"
									v-for="(transaction, index) in data"
								>
									<vs-td
										:data="transaction.code"
										@click="goToTransaction(transaction.id)"
									>
										<p class="product-code font-medium truncate">{{ transaction.code }}</p>
									</vs-td>

									<vs-td :data="transaction.type ? transaction.type.name : ''">
										{{ transaction.type.parent ? transaction.type.parent.name + ' / ' + transaction.type.name : transaction.type.name }}
									</vs-td>

									<vs-td :data="transaction.property ? transaction.property.fullAddress : ''">
										{{ transaction.property ? transaction.property.fullAddress : '' }}
										<br>
										<small>
											HRSZ: {{ transaction.property ? transaction.property.parcelNumber : '' }}
										</small>

									</vs-td>
									<vs-td>
										<div class="flex pull-right">
											<vx-tooltip text="Ügylethez">
												<vs-button
													class="btn-drop mr-2"
													type="flat"
													icon-pack="feather"
													icon="icon-external-link"
													size="small"
													color="dark"
													@click.stop="goToTransaction(transaction.id)"
												></vs-button>
											</vx-tooltip>
										</div>
									</vs-td>

								</vs-tr>
							</tbody>
						</template>
					</vs-table>
				</vx-card>
			</vs-col> -->
		</vs-row>
	</div>
</template>

<script>
import VueSimpleSuggest from 'vue-simple-suggest';
import { Validator } from 'vee-validate';
const dict = {
	custom: {
		firstName: {
			required: 'Vezetéknév megadása kötelező.',
		},
		lastName: {
			required: 'Keresztnév megadása kötelező.',
		},
		email: {
			required: 'E-mail cím megadása kötelező.',
		},
		customerSiteName: {
			required: 'Név megadása kötelező'
		},
		customerContactFirstName: {
			required: 'Vezetéknév megadása kötelező'
		},
		customerContactLastName: {
			required: 'Keresztnév megadása kötelező'
		},
	}
};
Validator.localize('en', dict);

export default {
	components: {
		VueSimpleSuggest
	},
	data() {
		return {
			currentSite: {
				name: ''
			},
			currentContact: {
			},
			method: '',
			newCustomer: false,
			editSiteModal: false,
			editContactModal: false,
			activeTab: 0,
			customer: {},
			transactions: null,
			streets: [],
			cities: [],
			streetTypes: [],
			counties: [
				{ text: 'Bács-Kiskun' },
				{ text: 'Baranya' },
				{ text: 'Békés' },
				{ text: 'Borsod-Abaúj-Zemplén' },
				{ text: 'Csongrád' },
				{ text: 'Fejér' },
				{ text: 'Győr-Moson-Sopron' },
				{ text: 'Hajdú-Bihar' },
				{ text: 'Heves' },
				{ text: 'Jász-Nagykun-Szolnok' },
				{ text: 'Komárom-Esztergom' },
				{ text: 'Nógrád' },
				{ text: 'Pest' },
				{ text: 'Somogy' },
				{ text: 'Szabolcs-Szatmár-Bereg' },
				{ text: 'Tolna' },
				{ text: 'Vas' },
				{ text: 'Veszprém' },
				{ text: 'Zala' },
			],
		}
	},
	watch: {
	},
	methods: {
		fetch() {
			this.$http.get("/api/customers/get/" + this.$route.params.id)
				.then((response) => {
					this.customer = response.data.data
				})
				.catch((error) => {
					if (error.response.status == 404) {
						this.$router.push({ name: 'megrendelok', params: { error: error.response.data.message } })
					}
					this.showError(error);
				})
		},
		validate() {
			this.$validator.validateAll("customer").then(result => {
				if (result) {
					this.save()
				}
			})
		},
		validateSite() {
			this.$validator.validateAll("customerSite").then(result => {
				console.log(result);
				if (result) {
					this.saveSite()
				}
			})
		},
		validateContact() {
			this.$validator.validateAll("customerContact").then(result => {
				console.log(result);
				if (result) {
					this.saveContact()
				}
			})
		},
		save() {
			this.$vs.loading()
			var postMethod = 'create'
			switch (this.newCustomer) {
				case true:
					postMethod = 'create'
					break;

				case false:
					postMethod = 'update/' + this.customer.id
					break;

				default:
					this.$vs.loading.close()
					this.$vs.notify({
						title: 'Hiba',
						text: 'Ismeretlen metódus',
						iconPack: 'feather',
						icon: 'icon-alert-circle',
						color: 'danger',
						position: 'bottom-center'
					})
					break;
			}

			this.$http.post("/api/customers/" + postMethod, this.customer)
				.then((response) => {
					this.$vs.loading.close()
					this.$vs.notify({
						title: 'Siker',
						text: 'Sikeres mentés',
						iconPack: 'feather',
						icon: 'icon-alert-circle',
						color: 'success',
						position: 'bottom-center'
					})

					if (postMethod == 'create') {
						this.$router.push('/megrendelo/' + response.data.data.id)
					}

				})
				.catch((error) => {
					this.$vs.loading.close()
					console.log('error');
					console.log(error);
				})
		},
		selectCounty(county) {
			this.customer.city = ''
			this.customer.zipCode = ''
			this.customer.street = ''
			this.$http.post('/api/transactions/getCities', { county: county.text })
				.then((response) => {
					this.cities = response.data.data
				})
				.catch((error) => {
					this.showError(error)
				})
		},
		selectCity(city) {
			this.customer.zipCode = city.zipCode
			this.customer.street = ''
			if (city.hasSub) {
				this.$http.post('/api/transactions/getStreets', { cityId: city.id })
					.then((response) => {
						this.streets = response.data.data
						console.log(this.streets);
					})
					.catch((error) => {
						this.showError(error)
					})
			} else {
				this.customer.streetType = ''
				this.streets = null
			}
		},
		getCityByZipcode() {
			if (this.customer.zipCode.length == 4) {
				this.$http.post('/api/transactions/getCityByZipcode', { zipCode: this.customer.zipCode })
					.then((response) => {
						if (response.data.data) {
							this.customer.city = response.data.data.city
							this.customer.county = response.data.data.county
							// if (type == 'customer') {
							// } else if (type == 'property') {
							// this.currentTransaction.property.city = response.data.data.city
							// }

							this.$http.post('/api/transactions/getStreets', { zipCode: this.customer.zipCode })
								.then((response) => {
									this.streets = response.data.data
								})
								.catch((error) => {
									this.showError(error)
								})
						} else {
							this.customer.city = ''
						}
					})
					.catch((error) => {
						this.showError(error)
					})
			}
		},
		selectStreet(street) {
			this.customer.selectedStreetId = street.id
			this.customer.zipCode = street.zipCode
			this.customer.streetName = street.streetName
			this.customer.streetType = street.streetType

			this.$http.post('/api/transactions/getStreetTypes', { streetName: street.streetName, zipCode: street.zipCode })
				.then((response) => {
					this.streetTypes = response.data.data
					console.log(this.streetTypes);
				})
				.catch((error) => {
					this.showError(error)
				})
		},
		addNewSite() {
			this.method = 'new'
			this.currentSite = {}
			this.editSiteModal = true
		},
		saveSite() {
			this.currentSite.customerId = this.customer.id
			this.currentSite.id = this.currentSite.id
			this.$http.post('/api/customers/site/save', this.currentSite)
				.then(() => {
					this.$vs.notify({
						text: 'Sikeres mentés',
						iconPack: 'feather',
						icon: 'icon-alert-circle',
						color: 'success',
						position: 'bottom-center'
					})
					this.fetch()
					this.editSiteModal = false
				})
				.catch((error) => {
					this.showError(error)
				})
			console.log(this.currentSite);
		},
		editSite(site) {
			this.method = 'edit'
			this.editSiteModal = true
			this.currentSite = site
		},
		deleteSite(id) {
			this.$vs.dialog({
				type: 'confirm',
				color: 'danger',
				title: `Biztosan törlöd az adatot?`,
				acceptText: 'IGEN, törlöm',
				cancelText: 'mégsem',
				text: '',
				accept: this.confirmDeleteSite,
				parameters: id
			})
		},
		confirmDeleteSite(id) {
			this.$http.delete("/api/customers/site/delete/" + id)
				.then(() => {
					this.$vs.notify({
						text: 'Sikeres törlés',
						iconPack: 'feather',
						icon: 'icon-alert-circle',
						color: 'success',
						position: 'bottom-center'
					})
					this.fetch();
				})
				.catch((error) => {
					this.showError(error)
				})
		},

		//Cusotmer Contacts
		addNewContact() {
			this.method = 'new'
			this.currentContact = {}
			this.editContactModal = true
			this.currentContact.siteId = this.customer.sites[0].id
		},
		saveContact() {
			this.currentContact.customerId = this.customer.id
			this.currentContact.id = this.currentContact.id
			this.$http.post('/api/customers/contact/save', this.currentContact)
				.then(() => {
					this.$vs.notify({
						text: 'Sikeres mentés',
						iconPack: 'feather',
						icon: 'icon-alert-circle',
						color: 'success',
						position: 'bottom-center'
					})
					this.fetch()
					this.editContactModal = false
				})
				.catch((error) => {
					this.showError(error)
				})
			console.log(this.currentContact);
		},
		editContact(contact) {
			this.method = 'edit'
			this.editContactModal = true
			this.currentContact = contact
		},
		deleteContact(id) {
			this.$vs.dialog({
				type: 'confirm',
				color: 'danger',
				title: `Biztosan törlöd az adatot?`,
				acceptText: 'IGEN, törlöm',
				cancelText: 'mégsem',
				text: '',
				accept: this.confirmDeleteContact,
				parameters: id
			})
		},
		confirmDeleteContact(id) {
			this.$http.delete("/api/customers/contact/delete/" + id)
				.then(() => {
					this.$vs.notify({
						text: 'Sikeres törlés',
						iconPack: 'feather',
						icon: 'icon-alert-circle',
						color: 'success',
						position: 'bottom-center'
					})
					this.fetch();
				})
				.catch((error) => {
					this.showError(error)
				})
		},
		goToTransaction(id) {
			console.log('"lkdsfhjksdhfjkdsfjkdsjk"');
			this.$router.push('/ugylet/' + id)
		},
		showError(error) {
			this.$vs.loading.close()
			this.$vs.notify({
				time: 8000,
				title: 'Hiba',
				text: 'Elnézést! A rendszer hibába ütközött. <br> --- <br>' + error,
				iconPack: 'feather',
				icon: 'icon-alert-circle',
				color: 'danger',
				position: 'bottom-center'
			})
		}
	},
	computed: {
	},
	created() {
		if (this.$route.params.id) {
			this.fetch()
		} else {
			this.newCustomer = true
		}
	}
}

</script>
